import { GameType, CategorySet, PunchcardCategory } from '../common/types';
import { Profile } from '@par/shared/types/player';
import { roundToOneDecimal } from '../utils/math';

export const getSoloStatValue = (
  gameType: GameType,
  categorySet: CategorySet,
  punchcardCategory: PunchcardCategory,
  viewProfile: Profile | undefined
) => {
  if (!viewProfile) return undefined;
  const { soloStats } = viewProfile;
  return soloStats[gameType][categorySet][punchcardCategory];
};

export const getSoloStat = (
  gameType: GameType,
  categorySet: CategorySet,
  punchcardCategory: PunchcardCategory,
  viewProfile: Profile | undefined
) => {
  const stat = getSoloStatValue(
    gameType,
    categorySet,
    punchcardCategory,
    viewProfile
  );
  if (punchcardCategory === 'gamesPlayed') {
    return stat !== undefined && stat !== null ? stat : '--';
  }
  return stat !== undefined && stat !== null
    ? `${stat > 0 ? '+' : ''}${roundToOneDecimal(stat)}`
    : '--';
};
